
const PAGINATION_LIMIT_KEY = 'admin_pagination_limits';

interface PaginationLimits {
  [moduleName: string]: number;
}

export function getPaginationLimit(moduleName: string, defaultValue: number = 10): number {
  try {
    const storedLimits = localStorage.getItem(PAGINATION_LIMIT_KEY);
    if (storedLimits) {
      const limits: PaginationLimits = JSON.parse(storedLimits);
      return limits[moduleName] || defaultValue;
    }
  } catch (error) {
    console.error('Error reading pagination limit from localStorage:', error);
  }
  return defaultValue;
}

export function setPaginationLimit(moduleName: string, limit: number): void {
  try {
    const storedLimits = localStorage.getItem(PAGINATION_LIMIT_KEY);
    const limits: PaginationLimits = storedLimits ? JSON.parse(storedLimits) : {};
    
    limits[moduleName] = limit;
    localStorage.setItem(PAGINATION_LIMIT_KEY, JSON.stringify(limits));
  } catch (error) {
    console.error('Error storing pagination limit to localStorage:', error);
  }
}
